(() => {
  if (window.loshenDescriptionStoryLoaded) return;
  window.loshenDescriptionStoryLoaded = true;

  const french = document.documentElement.lang.toLowerCase().startsWith('fr');
  const copy = (en, fr) => french ? fr : en;
  const handle = location.pathname.match(/\/products\/([^/]+)/)?.[1] || '';
  const shampoo = handle === 'bur-bur-growing-season-shampoo';
  const brush = handle === 'bur-bur-the-mermaid-wet-detangling-brush';
  const root = window.Shopify?.routes?.root || (french ? '/fr/' : '/');

  const drawings = {
    water: 'M32 8C27 17 17 26 17 37a15 15 0 0 0 30 0C47 26 37 17 32 8ZM24 37a8 8 0 0 0 8 8',
    bottle: 'M26 9h12v8H26zM24 17h16l3 7v31H21V24l3-7ZM21 31h22M21 45h22M28 36h8',
    jar: 'M17 23h30v7H17zM19 30v21h26V30M25 38h14M28 44h8',
    brush: 'M24 8c-6 0-10 5-10 12v8c0 7 4 12 10 12h6v15h8V40h2c6 0 10-5 10-12v-8c0-7-4-12-10-12ZM23 16v16M30 16v16M37 16v16M44 16v16',
    leaf: 'M15 48C7 24 25 11 50 11c0 25-11 42-35 37ZM14 49l26-26M25 37V24M25 37h13',
    root: 'M31 24c-8 6-8 17-4 31 9-8 13-19 8-30M31 24C18 24 13 17 14 10c11 1 17 5 17 14ZM32 24C32 13 40 8 49 10c-1 9-8 14-17 14ZM26 37l8 3M26 45l5 2',
    aloe: 'M30 54C16 42 13 31 14 16c11 10 17 21 18 38ZM32 54C28 33 29 19 35 7c6 19 7 33-3 47ZM34 54c2-18 9-29 20-36-1 16-7 28-20 36Z',
    grain: 'M32 56V12M32 21c-9 0-13-5-12-12 8 0 12 5 12 12ZM32 32c-9 0-14-5-13-12 8 0 13 5 13 12ZM32 44c-9 0-14-5-13-12 8 0 13 5 13 12ZM32 26c9 0 13-5 12-12-8 0-12 5-12 12ZM32 39c9 0 14-5 13-12-8 0-13 5-13 12Z',
    molecule: 'M18 22l14-8 14 8v16l-14 8-14-8V22ZM18 22l-8-5M46 38l8 5M32 46v10M32 14V5M25 24v10M39 24v10',
    wood: 'M21 8h22v48H21zM28 8c-6 15 9 23 2 48M37 8c-7 13 8 25 0 48',
    bristles: 'M13 45h38v7H13zM18 45V19c0-6 6-6 6 0M28 45V12c0-6 6-6 6 0M38 45V17c0-6 6-6 6 0M48 45V26',
    cushion: 'M12 36c0-13 40-13 40 0v10H12V36ZM12 40c12 5 28 5 40 0M26 20v-8M38 20v-8',
    hand: 'M18 34V23c0-5 6-5 6 0v10-18c0-5 6-5 6 0v17-21c0-5 6-5 6 0v22-17c0-5 6-5 6 0v24l4-6c4-5 10-1 6 5L40 55H24L13 40c-4-6 2-10 5-6Z',
    hair: 'M21 9c-14 18 15 28 0 46M32 9c-14 18 15 28 0 46M43 9c-14 18 15 28 0 46',
    clock: 'M32 10a22 22 0 1 0 0 44 22 22 0 0 0 0-44ZM32 18v15l10 6',
    sparkle: 'M32 8l5 18 18 6-18 5-5 19-5-19-18-5 18-6 5-18Z'
  };

  const icon = name => {
    const svg = document.createElementNS(
      'http://www.w3.org/2000/svg',
      'svg'
    );

    const attributes = {
      viewBox: '0 0 64 64',
      width: '64',
      height: '64',
      fill: 'none',
      stroke: 'currentColor',
      'stroke-width': '1.25',
      'stroke-linecap': 'round',
      'stroke-linejoin': 'round',
      'aria-hidden': 'true',
      focusable: 'false',
      class: 'lc-story-icon'
    };

    for (const [key, value] of Object.entries(attributes)) {
      svg.setAttribute(key, value);
    }

    const path = document.createElementNS(svg.namespaceURI, 'path');
    path.setAttribute('d', drawings[name] || drawings.sparkle);
    svg.append(path);

    return svg;
  };

  const normalise = value => value
    .normalize('NFD')
    .replace(/[\u0300-\u036f]/g, '')
    .toLowerCase()
    .replace(/[’']/g, '')
    .replace(/\s+/g, ' ')
    .trim();

  const element = (tag, className, text) => {
    const node = document.createElement(tag);

    if (className) node.className = className;
    if (text !== undefined) node.textContent = text;

    return node;
  };

  const groupFor = title => {
    const key = normalise(title);

    if (/[?？]\s*$/.test(key)) return 'overview';

    if (/\binci\b|full.*(formula|ingredient)|formule complete|liste complete/.test(key)) {
      return 'formula';
    }

    if (/^(key ingredients|ingredients|active ingredients|actifs|principaux ingredients)/.test(key)) {
      return 'ingredients';
    }

    if (/^(how to use|directions|usage|application|mode demploi|conseils dutilisation|utilisation|care\b|entretien\b)/.test(key)) {
      return 'routine';
    }

    if (/^(questions|faq\b|frequently asked)/.test(key)) {
      return 'reviews';
    }

    if (/^(clinical results|results\b|clinical studies|resultats\b|etudes cliniques)/.test(key)) {
      return 'results';
    }

    if (/loshen.*recommend|loshen.*recommand|why we love|pourquoi.*aim|notre recommandation/.test(key)) {
      return 'recommendation';
    }

    return 'overview';
  };

  const hasContent = node => Boolean(
    node.textContent.trim() ||
    node.querySelector('img, video, iframe, table, audio')
  );

  function iconFor(text) {
    const key = normalise(text);

    if (/bristle|poils|nylon/.test(key)) return 'bristles';
    if (/handle|wood|manche|bois/.test(key)) return 'wood';
    if (/cushion|coussin/.test(key)) return 'cushion';
    if (/burdock|bardane/.test(key)) return 'root';
    if (/aloe|aloes/.test(key)) return 'aloe';
    if (/rice|riz|protein/.test(key)) return 'grain';
    if (/nettle|ortie|leaf|feuille/.test(key)) return 'leaf';
    if (/panthenol|niacinamide|peptide/.test(key)) return 'molecule';
    if (/brush|brosse|detang|demel|ends|pointes/.test(key)) return 'brush';
    if (/oil|huile|rinse|rince|wet|water|eau|soak|mouille/.test(key)) return 'water';
    if (/condition|mask|masque|apres.shampoo/.test(key)) return 'jar';
    if (/shampoo|wash|lave|cleanse|nettoy/.test(key)) return 'bottle';
    if (/massage|palm|main|emuls|handcrafted|fabriq|origin|korea|coree/.test(key)) return 'hand';
    if (/minute|daily|jour|time|temps/.test(key)) return 'clock';

    return 'hair';
  }

  function title(text, emphasis) {
    const heading = element('h2', 'lc-pdp__heading lc-story-heading');

    heading.append(
      document.createTextNode(text + ' '),
      element('em', '', emphasis)
    );

    return heading;
  }

  function decorateList(list, className) {
    list.classList.add(className);

    [...list.children].forEach(item => {
      const body = element('div', 'lc-story-item-copy');

      body.append(...item.childNodes);
      item.append(icon(iconFor(body.textContent)), body);
    });
  }

  function facts() {
    if (!shampoo && !brush) return null;

    const section = element(
      'section',
      'lc-description-section lc-story-facts'
    );

    section.dataset.mobileGroup = 'overview';
    section.setAttribute(
      'aria-label',
      copy('At a glance', 'En un coup d’œil')
    );

    const data = shampoo ? [
      [
        'bottle',
        copy('The step', 'L’étape'),
        copy('Cleanse the scalp', 'Nettoyer le cuir chevelu')
      ],
      [
        'hair',
        copy('The feel', 'La sensation'),
        copy('Soft, light lengths', 'Des longueurs souples et légères')
      ],
      [
        'water',
        copy('The moment', 'Le moment'),
        copy(
          'Wash day · before conditioner',
          'Jour de lavage · avant le revitalisant'
        )
      ]
    ] : [
      [
        'bristles',
        copy('The bristles', 'Les picots'),
        copy('Flexible nylon', 'Nylon souple')
      ],
      [
        'water',
        copy('The moment', 'Le moment'),
        copy('Wet or dry hair', 'Cheveux mouillés ou secs')
      ],
      [
        'wood',
        copy('The handle', 'Le manche'),
        copy(
          'Hand-polished beech wood',
          'Bois de hêtre poli à la main'
        )
      ]
    ];

    const list = element('dl');

    data.forEach(([drawing, label, value]) => {
      const item = element('div');

      item.append(
        icon(drawing),
        element('dt', '', label),
        element('dd', '', value)
      );

      list.append(item);
    });

    section.append(list);

    return section;
  }

  function ritualSection(body) {
    const list = [...body.children].find(node =>
      node.matches('ol') &&
      /ritual|rituel/i.test(node.previousElementSibling?.textContent || '')
    );

    if (
      !list ||
      list.hasAttribute('start') ||
      list.hasAttribute('reversed') ||
      list.hasAttribute('type') ||
      list.querySelector('li[value]')
    ) {
      return null;
    }

    const section = element(
      'section',
      'lc-description-section lc-pdp__section lc-story-ritual'
    );

    section.dataset.mobileGroup = 'routine';

    const originalTitle = list.previousElementSibling;

    section.append(
      title(
        copy('Your ritual,', 'Votre rituel,'),
        copy('step by step.', 'un geste à la fois.')
      ),
      originalTitle,
      list
    );

    originalTitle.classList.add('lc-story-kicker');
    decorateList(list, 'lc-story-ritual-list');

    if (shampoo) {
      [...list.children].forEach(item => {
        if (/growing season nourishing shampoo/i.test(item.textContent)) {
          item.classList.add('lc-story-current');

          item.append(
            element(
              'span',
              'lc-story-current-label',
              copy('This product', 'Ce produit')
            )
          );
        }
      });
    }

    return section;
  }

  function pairSection() {
    if (!shampoo && !brush) return null;

    const section = element(
      'section',
      'lc-description-section lc-pdp__section lc-story-pair-section'
    );

    section.dataset.mobileGroup = 'routine';
    section.hidden = true;

    section.append(
      title(
        copy('Complete the', 'Complétez le'),
        copy('ritual.', 'rituel.')
      )
    );

    const grid = element('div', 'lc-story-pairs');
    section.append(grid);

    return { section, grid };
  }

  async function loadPairs(pair) {
    const products = [
      [
        'bur-bur-growing-season-conditioner',
        copy('After cleansing', 'Après le nettoyage'),
        copy(
          'The conditioning step after shampoo, or extra slip for detangling.',
          'Après le shampooing, ou pour faciliter le démêlage.'
        )
      ],
      [
        'bur-bur-growing-season-hair-mask',
        copy('On mask days', 'Les jours de masque'),
        copy(
          'A deeper conditioning step. Work through gently with the Mermaid brush.',
          'Un soin revitalisant plus riche. Répartissez-le délicatement avec la brosse Mermaid.'
        )
      ]
    ];

    const results = await Promise.allSettled(
      products.map(async ([productHandle, label, description]) => {
        const response = await fetch(
          root + 'products/' + productHandle + '.js',
          {
            credentials: 'same-origin',
            signal: AbortSignal.timeout(8000)
          }
        );

        if (!response.ok) return null;

        const product = await response.json();

        if (!product.title || product.handle !== productHandle) {
          return null;
        }

        const card = element('a', 'lc-story-pair');
        card.href = root + 'products/' + productHandle;

        if (product.featured_image) {
          const image = element('img');
          const url = new URL(product.featured_image, location.origin);

          if (url.protocol === 'https:') {
            url.searchParams.set('width', '320');

            image.src = url.href;
            image.alt = '';
            image.loading = 'lazy';
            image.width = 160;
            image.height = 160;

            card.append(image);
          }
        }

        const body = element('div');

        body.append(
          element('p', 'lc-story-kicker', label),
          element('h3', '', product.title),
          element('p', '', description)
        );

        if (!product.available) {
          body.append(
            element(
              'p',
              'lc-story-stock',
              copy('Currently sold out', 'Actuellement épuisé')
            )
          );
        }

        body.append(
          element(
            'span',
            'lc-story-link',
            copy('Explore product', 'Découvrir le produit')
          )
        );

        card.append(body);

        return card;
      })
    );

    results.forEach(result => {
      if (result.status === 'fulfilled' && result.value) {
        pair.grid.append(result.value);
      }
    });

    pair.section.hidden = !pair.grid.children.length;
  }

  function ingredientExplorer(body, title, prefix) {
    const children = [...body.children];
    const list = children.find(node => node.matches('ul'));

    if (
      !list ||
      [...list.children].some(node => node.tagName !== 'LI')
    ) {
      return false;
    }

    const entries = [...list.children].map(item => {
      const label = item.firstElementChild;

      if (
        !label?.matches('strong, b') ||
        !/:\s*$/.test(label.textContent) ||
        item.textContent.trim() === label.textContent.trim()
      ) {
        return null;
      }

      const before = [...item.childNodes].slice(
        0,
        [...item.childNodes].indexOf(label)
      );

      if (before.some(node => node.textContent.trim())) return null;

      const copy = item.cloneNode(true);
      copy.firstElementChild.remove();

      return {
        name: label.textContent.replace(/:\s*$/, '').trim(),
        copy
      };
    });

    if (
      !entries.length ||
      entries.some(entry => !entry || !entry.name)
    ) {
      return false;
    }

    const explorer = element('div', 'lc-description-ingredients');
    const tabs = element('div', 'lc-pdp__ingredient-tabs');

    tabs.setAttribute('role', 'tablist');
    tabs.setAttribute('aria-label', title);

    const panels = element('div');
    const buttons = [];
    const panelNodes = [];

    const activate = (index, focus = false) => {
      buttons.forEach((button, position) => {
        const selected = position === index;

        button.setAttribute('aria-selected', String(selected));
        button.tabIndex = selected ? 0 : -1;
        panelNodes[position].hidden = !selected;
      });

      if (focus) buttons[index].focus();
    };

    entries.forEach((entry, index) => {
      const button = element(
        'button',
        'lc-pdp__ingredient-tab',
        entry.name
      );

      button.type = 'button';
      button.id = `${prefix}-tab-${index}`;
      button.setAttribute('role', 'tab');
      button.setAttribute('aria-controls', `${prefix}-panel-${index}`);

      const panel = element(
        'article',
        'lc-pdp__ingredient lc-pdp__ingredient--text'
      );

      panel.classList.add('lc-story-ingredient');
      panel.id = `${prefix}-panel-${index}`;
      panel.setAttribute('role', 'tabpanel');
      panel.setAttribute('aria-labelledby', button.id);
      panel.tabIndex = 0;

      const copy = element('div', 'lc-pdp__copy');
      copy.append(...entry.copy.childNodes);

      const inner = element('div');

      inner.append(
        element(
          'h3',
          'lc-pdp__subheading lc-pdp__ingredient-name',
          entry.name
        ),
        copy
      );

      const illustration = element('div', 'lc-story-ingredient-art');
      illustration.append(icon(iconFor(entry.name)));

      panel.append(illustration, inner);

      buttons.push(button);
      panelNodes.push(panel);
      tabs.append(button);
      panels.append(panel);

      button.addEventListener('click', () => activate(index));

      button.addEventListener('keydown', event => {
        let next;

        if (event.key === 'ArrowRight') {
          next = (index + 1) % entries.length;
        } else if (event.key === 'ArrowLeft') {
          next = (index - 1 + entries.length) % entries.length;
        } else if (event.key === 'Home') {
          next = 0;
        } else if (event.key === 'End') {
          next = entries.length - 1;
        } else {
          return;
        }

        event.preventDefault();
        activate(next, true);
      });
    });

    explorer.append(tabs, panels);
    list.replaceWith(explorer);
    activate(0);

    return true;
  }

  function groupDescription(container) {
    const groups = [];
    let current = { title: '', kind: 'overview', level: 0, nodes: [] };
    groups.push(current);

    for (const node of [...container.childNodes]) {
      const heading = node.nodeType === 1 && /^H[1-6]$/.test(node.tagName);
      const text = node.textContent.trim();
      const kind = heading ? groupFor(text) : 'overview';
      const level = heading ? Number(node.tagName.slice(1)) : 0;
      const nested = heading && current.title && kind === 'overview' && (
        level > current.level ||
        (['ingredients', 'formula', 'routine', 'results', 'reviews'].includes(current.kind) &&
          (/[?？]\s*$/.test(text) || level === 3 || level === 4))
      );

      if (heading && text && !nested) {
        current = {
          title: text, kind, level, headingNodes: [...node.childNodes],
          nodes: [], id: node.id
        };
        groups.push(current);
      } else {
        current.nodes.push(node);
      }
    }

    return groups;
  }

  function groupQuestions(body) {
    const fragment = document.createDocumentFragment();
    let question;
    let answer;

    const flush = () => {
      if (!question) return;
      if (!hasContent(answer)) {
        fragment.append(question, ...answer.childNodes);
        return;
      }
      const item = element('details', 'lc-pdp__disclosure lc-description-question');
      if (question.id) item.id = question.id;
      const summary = element('summary');
      summary.append(...question.childNodes);
      const plus = element('span', 'lc-pdp__plus');
      plus.setAttribute('aria-hidden', 'true');
      summary.append(plus);
      item.append(summary, answer);
      fragment.append(item);
    };

    for (const node of [...body.childNodes]) {
      const heading = node.nodeType === 1 && /^H[1-6]$/.test(node.tagName);
      const paragraph = node.nodeType === 1 && node.matches('p') &&
        /^[^?？]+[?？]\s*$/.test(node.textContent.trim()) &&
        node.querySelector('strong, b');
      if ((heading || paragraph) && /[?？]\s*$/.test(node.textContent.trim())) {
        flush();
        question = node;
        answer = element('div', 'lc-pdp__copy lc-description-copy');
      } else {
        (answer || fragment).append(node);
      }
    }
    flush();
    body.replaceChildren(fragment);
  }

  function build(source) {
    if (source.dataset.lcDescriptionReady) return;

    const draft = source.cloneNode(true);
    let container = draft;

    while (
      container.children.length === 1 &&
      container.firstElementChild.matches('div, section, article') &&
      ![...container.childNodes].some(node =>
        node.nodeType === 3 && node.textContent.trim()
      )
    ) {
      container = container.firstElementChild;
    }

    const headings = [...container.children].filter(node =>
      /^H[1-6]$/.test(node.tagName)
    );

    if (!headings.length) {
      source.dataset.lcDescriptionReady = 'plain';
      return;
    }

    const groups = groupDescription(container);

    const fragment = document.createDocumentFragment();
    const glance = facts();

    if (glance) fragment.append(glance);

    let ritual;

    groups.forEach((group, index) => {
      const body = element(
        'div',
        'lc-pdp__copy lc-description-copy'
      );

      body.append(...group.nodes);

      if (!hasContent(body) && !group.title) return;

      const kind = group.kind;
      const disclosure = hasContent(body) && ['routine', 'formula'].includes(kind);

      const section = element(
        disclosure ? 'details' : 'section',
        `lc-description-section ${disclosure ? 'lc-pdp__disclosure' : 'lc-pdp__section'}`
      );

      if (kind === 'formula' || (brush && kind === 'routine')) section.open = true;

      section.dataset.mobileGroup =
        kind === 'formula'
          ? 'ingredients'
          : kind === 'recommendation'
            ? 'overview'
            : kind;

      section.id = group.id || `${source.id}-section-${index}`;
      section.tabIndex = -1;

      if (kind === 'recommendation') {
        section.classList.add('lc-description-recommendation');
      }

      if (kind === 'recommendation') {
        ritual = ritualSection(body) || ritual;
        body.querySelector(':scope > p')?.classList.add('lc-story-quote');
      }

      if (!group.title) {
        section.classList.add('lc-story-intro');

        const lead = body.querySelector(':scope > p:first-child');

        if (lead?.querySelector('strong, b')) {
          lead.classList.add('lc-story-intro-lead');
        }

        if (brush || shampoo) {
          section.append(
            brush
              ? title(
                  copy(
                    'A little less pulling.',
                    'Un peu moins de nœuds.'
                  ),
                  copy(
                    'A little more patience.',
                    'Un peu plus de douceur.'
                  )
                )
              : title(
                  copy(
                    'Good hair days begin',
                    'Les beaux cheveux commencent'
                  ),
                  copy(
                    'at the scalp.',
                    'au cuir chevelu.'
                  )
                )
          );
        }
      }

      if (group.title) {
        const heading = element(
          disclosure ? 'summary' : 'h2',
          disclosure ? '' : 'lc-pdp__heading'
        );

        heading.append(...group.headingNodes);

        if (disclosure) {
          const plus = element('span', 'lc-pdp__plus');
          plus.setAttribute('aria-hidden', 'true');
          heading.append(plus);
        }

        section.append(heading);
      }

      if (kind === 'ingredients') {
        ingredientExplorer(body, group.title, `${source.id}-${index}`);
      }

      if (kind === 'reviews') groupQuestions(body);

      if (
        /^(details|materials|materiaux|composition de la brosse)$/.test(
          normalise(group.title)
        )
      ) {
        body.querySelectorAll(':scope > ul').forEach(list => {
          if (
            [...list.children].every(item =>
              item.firstElementChild?.matches('strong, b')
            )
          ) {
            decorateList(list, 'lc-story-materials');
          }
        });
      }

      if (kind === 'routine') {
        body
          .querySelectorAll(':scope > ol:not([start]):not([reversed]):not([type])')
          .forEach(list => {
            if (list.querySelector(':scope > li[value]')) return;

            decorateList(list, 'lc-description-steps');
          });
      }

      section.append(body);
      fragment.append(section);
    });

    if (ritual) {
      const note = fragment.querySelector('.lc-description-recommendation');

      if (note) {
        note.before(ritual);
      } else {
        fragment.append(ritual);
      }
    }

    const pair = pairSection();

    if (pair) fragment.append(pair.section);

    source.classList.remove('lc-pdp__section', 'lc-pdp__copy');
    source.replaceChildren(fragment);
    source.dataset.lcDescriptionReady = 'sections';

    const editorialTitle = source
      .closest('.lc-pdp-design')
      ?.querySelector('.lc-pdp__header .lc-pdp__editorial-title');

    if (editorialTitle) {
      editorialTitle.style.fontFamily = '"Playfair Display", Georgia, serif';
    }

    source.dispatchEvent(
      new CustomEvent('loshen:description-ready', { bubbles: true })
    );

    if (pair) loadPairs(pair).catch(() => {});
  }

  function initialise(root = document) {
    root.querySelectorAll('[data-lc-description]').forEach(source => {
      try {
        build(source);
      } catch (error) {
        console.warn(
          'Loshen description kept in its original format.',
          error
        );
      }
    });
  }

  if (document.readyState === 'loading') {
    document.addEventListener(
      'DOMContentLoaded',
      () => initialise(),
      { once: true }
    );
  } else {
    initialise();
  }

  document.addEventListener(
    'shopify:section:load',
    event => initialise(event.target)
  );
})();